import React, { useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";

export default function AboutUs() {
  const navigate = useNavigate();
  const [secretToast, setSecretToast] = useState("");
  const clickCountRef = useRef(0);
  const clickTimerRef = useRef(null);
  const handleFounderClick = () => {
    clickCountRef.current += 1;
    if (clickTimerRef.current) clearTimeout(clickTimerRef.current);
    clickTimerRef.current = setTimeout(() => { clickCountRef.current = 0; }, 3000);
    if (clickCountRef.current >= 5) {
      clickCountRef.current = 0;
      const current = localStorage.getItem('admin_hide_bridge_tab') === 'true';
      const next = !current;
      localStorage.setItem('admin_hide_bridge_tab', next ? 'true' : 'false');
      setSecretToast(next ? 'Bridge tab hidden' : 'Bridge tab visible');
      setTimeout(() => setSecretToast(""), 2000);
    }
  };
  const isLoggedIn = !!(localStorage.getItem("access_token") || localStorage.getItem("token"));
  const userRole = localStorage.getItem("user_role") || "trader";
  const dashboardPath = isLoggedIn ? `/${userRole}` : "/login";

  return (
    <div style={{ minHeight: "100vh", background: "var(--bg)", color: "var(--text-main)", overflowX: "hidden" }}>

      {/* NAV */}
      <header style={{ position: "sticky", top: 0, zIndex: 50,
        background: "var(--bg-surface)", backdropFilter: "blur(12px)",
        borderBottom: "1px solid var(--border-subtle)" }}>
        <div style={{ maxWidth: 1080, margin: "0 auto", padding: "0 24px", height: 58,
          display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <Link to="/" style={{ textDecoration: "none" }}>
            <div style={{ fontWeight: 800, fontSize: 17, color: "var(--text-main)", letterSpacing: "-0.02em" }}>
              Crunch<span style={{ color: "var(--accent)" }}>Alpha</span>
            </div>
            <div style={{ fontSize: 10, color: "var(--accent)", marginTop: 1 }}>
              Risk Controlled Copy Trading
            </div>
          </Link>
          <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
            <Link to="/" style={{ fontSize: 13, color: "var(--text-muted)", textDecoration: "none" }}>Home</Link>
            {isLoggedIn ? (
              <Link to={dashboardPath} style={{ padding: "7px 18px", borderRadius: "var(--radius-md)",
                background: "var(--accent)", color: "#fff", fontSize: 13, fontWeight: 600, textDecoration: "none" }}>
                Dashboard
              </Link>
            ) : (
              <>
                <Link to="/login" style={{ fontSize: 13, color: "var(--text-muted)", textDecoration: "none" }}>Sign in</Link>
                <Link to="/register" style={{ padding: "7px 18px", borderRadius: "var(--radius-md)",
                  background: "var(--accent)", color: "#fff", fontSize: 13, fontWeight: 600, textDecoration: "none" }}>
                  Get started
                </Link>
              </>
            )}
          </div>
        </div>
      </header>

      {/* CONTENT */}
      <main style={{ maxWidth: 760, margin: "0 auto", padding: "56px 24px 80px" }}>

        {/* Label */}
        <div style={{ fontSize: 11, color: "var(--accent)", fontWeight: 700, letterSpacing: "0.1em",
          textTransform: "uppercase", marginBottom: 12 }}>About Us</div>

        {/* Title */}
        <h1 style={{ fontSize: 32, fontWeight: 800, letterSpacing: "-0.025em", margin: "0 0 20px",
          color: "var(--text-main)", lineHeight: 1.2 }}>
          Building a more transparent way to copy trade.<br />A growing space where traders, analysts, and investors can grow together — starting with copy trading, and evolving from there.
        </h1>

        {/* Mission */}
        <p style={{ fontSize: 15, color: "var(--text-muted)", lineHeight: 1.85, margin: "0 0 16px" }}>
          CrunchAlpha started from a simple observation: copy trading has real potential, but most platforms don't handle risk carefully enough, and performance numbers aren't always shown clearly — for traders being copied, analysts providing signals, or investors following them.
        </p>
        <p style={{ fontSize: 15, color: "var(--text-muted)", lineHeight: 1.85, margin: "0 0 48px" }}>
          We wanted to try building it differently.
        </p>

        {/* Divider */}
        <div style={{ height: 1, background: "var(--border-subtle)", marginBottom: 48 }} />

        {/* Founder section */}
        <div style={{ marginBottom: 48 }}>
          <p style={{ fontSize: 15, color: "var(--text-muted)", lineHeight: 1.85, margin: "0 0 16px" }}>
            This started from years of following the forex trading world closely — trading, learning, occasionally struggling, and paying attention to what other copy trading platforms got right and wrong along the way.
          </p>
          <p style={{ fontSize: 15, color: "var(--text-muted)", lineHeight: 1.85, margin: "0 0 20px" }}>
            A few patterns kept showing up:
          </p>

          {/* Problems list */}
          <div style={{ display: "flex", flexDirection: "column", gap: 12, marginBottom: 28 }}>
            {[
              "Risk management was often an afterthought",
              "Performance numbers weren't always presented clearly",
              "Traders and analysts with real skill didn't always get rewarded for consistency",
              "Investors sometimes lost money even when following top-ranked accounts or signals",
            ].map(item => (
              <div key={item} style={{ display: "flex", gap: 12, alignItems: "flex-start" }}>
                <div style={{ width: 5, height: 5, borderRadius: "50%", background: "var(--danger)",
                  flexShrink: 0, marginTop: 9 }} />
                <span style={{ fontSize: 14, color: "var(--text-muted)", lineHeight: 1.7 }}>{item}</span>
              </div>
            ))}
          </div>

          <p style={{ fontSize: 15, color: "var(--text-muted)", lineHeight: 1.85, margin: "0 0 16px" }}>
            These observations shaped how CrunchAlpha is built.
          </p>
          <p style={{ fontSize: 15, color: "var(--text-muted)", lineHeight: 1.85, margin: "0 0 36px" }}>
            With AlphaRank (a transparent, risk-adjusted scoring system for both traders and analysts), AUM-based position sizing, and automatic risk flags, performance is measured on consistency and discipline, not just raw numbers.
          </p>
        </div>

        {/* What we built */}
        <div style={{ background: "var(--accent-soft)", border: "1px solid var(--accent-border)",
          borderRadius: "var(--radius-xl)", padding: "28px 28px 24px", marginBottom: 48 }}>
          <div style={{ fontSize: 13, fontWeight: 600, color: "var(--accent)", marginBottom: 16 }}>
            We're still early. We're working closely with a group of traders, analysts, and investors to test, learn, and improve the platform as we go — every change comes from real usage, not assumptions.
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            {[
              "Traders building a track record",
              "Analysts providing signals",
              "Investors looking to follow with more transparency",
            ].map(item => (
              <div key={item} style={{ display: "flex", gap: 12, alignItems: "flex-start" }}>
                <div style={{ width: 5, height: 5, borderRadius: "50%", background: "var(--accent)",
                  flexShrink: 0, marginTop: 9 }} />
                <span style={{ fontSize: 14, color: "var(--text-main)", lineHeight: 1.7 }}>{item}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Current stage */}
        <p style={{ fontSize: 15, color: "var(--text-muted)", lineHeight: 1.85, margin: "0 0 16px" }}>
          If you value discipline over hype, we'd love to have you along for this.
        </p>


        {/* Closing quote */}
        <div style={{ borderLeft: "3px solid var(--accent)", paddingLeft: 24, marginBottom: 48 }}>
          <p style={{ fontSize: 16, color: "var(--text-main)", lineHeight: 1.85, margin: "0 0 16px",
            fontStyle: "italic" }}>
            "Let's build a more transparent future for copy trading — together."
          </p>
          <div onClick={handleFounderClick} style={{ fontSize: 14, fontWeight: 600, color: "var(--text-main)", cursor: "default", userSelect: "none" }}>Hendri Saputro</div>
          <div onClick={handleFounderClick} style={{ fontSize: 12, color: "var(--text-faint)", marginTop: 2, cursor: "default", userSelect: "none" }}>Founder of CrunchAlpha</div>
          {secretToast && (
            <div style={{ fontSize: 11, color: "var(--text-faint)", marginTop: 4, opacity: 0.6 }}>{secretToast}</div>
          )}
        </div>

        {/* CTA */}
        <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
          <Link to="/register" style={{ padding: "11px 24px", borderRadius: "var(--radius-md)",
            background: "var(--accent)", color: "#fff", fontSize: 14, fontWeight: 600, textDecoration: "none" }}>
            Join CrunchAlpha
          </Link>
          <Link to="/" style={{ padding: "10px 20px", borderRadius: "var(--radius-md)",
            background: "transparent", border: "1px solid var(--border)",
            color: "var(--text-muted)", fontSize: 13, textDecoration: "none" }}>
            Back to home
          </Link>
        </div>
      </main>

      {/* FOOTER */}
      <footer style={{ borderTop: "1px solid var(--border-subtle)", padding: "20px 24px",
        maxWidth: 1080, margin: "0 auto", fontSize: 11, color: "var(--text-faint)",
        display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: 8, alignItems: "center" }}>
        <div>
          <span style={{ fontWeight: 700, color: "var(--text-main)" }}>
            Crunch<span style={{ color: "var(--accent)" }}>Alpha</span>
          </span>
          {" "}© 2026 · Non-custodial · Multi-broker · Trading involves risk.
        </div>
        <div style={{ display: "flex", gap: 20 }}>
          <Link to="/legal/terms" style={{ color: "var(--text-faint)", textDecoration: "none" }}>Terms</Link>
          <Link to="/legal/privacy" style={{ color: "var(--text-faint)", textDecoration: "none" }}>Privacy</Link>
          <Link to="/legal/risk" style={{ color: "var(--text-faint)", textDecoration: "none" }}>Risk Disclosure</Link>
        </div>
      </footer>

    </div>
  );
}
